import { IHomeService } from './IHomeService';
import BaseService from '@/services/baseService';
import { HomeFilterDto } from '@/types/HomeFilterDto';
import { TvsBuchungApiDtoSearchResponseApi, KontoSaldoApiDto } from '@/api-schema';
import { AxiosResponse } from 'axios';

export class HomeService extends BaseService implements IHomeService {
    private KONTO_URL: string;
    private DOKUMENTE_URL: string;
    constructor() {
        super();
        this.KONTO_URL = `${this.BASE_URL}konto`;
        this.DOKUMENTE_URL = `${this.BASE_URL}dokumente`;

        console.debug('HomeService::constructor', this.KONTO_URL);
    }

    async loadTabs(): Promise<Array<KontoSaldoApiDto>> {
        return super.GET<Array<KontoSaldoApiDto>>(`${this.KONTO_URL}`).then((response) => {
            return response;
        });
    }
    async loadValues(filter: HomeFilterDto): Promise<TvsBuchungApiDtoSearchResponseApi> {
        return super.GET<TvsBuchungApiDtoSearchResponseApi>(`${this.KONTO_URL}/bewegungen/` + super.serializeObjectToQuerystring(filter)).then((response) => {
            return response;
        });
    }
    async downloadRechnung(id: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.DOKUMENTE_URL}/download/` + id).then((response) => {
            return response;
        });
    }
    async downloadMonatJounalAsCsv(id: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.KONTO_URL}/monatjournal/csv/` + id).then((response) => {
            return response;
        });
    }
}

export const homeService = new HomeService();
